export const ExportFormat = {
  Csv: 'Csv',
  Pdf: 'Pdf',
  Xlsx: 'Xlsx',
} as const;

export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];

export const Forms = {
  None: 'None',
  Customers: 'Customers',
  Receipts: 'Receipts',
  Transactions: 'Transactions',
  CollectionCases: 'CollectionCases',
  PromisesToPay: 'PromisesToPay',
  PromiseTransactions: 'PromiseTransactions',
  CreatePromiseTransactions: 'CreatePromiseTransactions',
  CaseTransactions: 'CaseTransactions',
  Emails: 'Emails',
} as const;

export type Forms = (typeof Forms)[keyof typeof Forms];

export type ErpExportEvent = {
  customExportAllDownloadUrl?: string;
  fileName?: string;
  receiptId: string;
};

export type ColumnInput = {
  name: string;
  displayName?: string;
};

export type ExportInput = {
  columns: ColumnInput[];
  filter?: string | null;
  form: Forms;
  format: ExportFormat;
};

export type CreateExportJobMutationResult =
  | { id: string }
  | null;
